import {FC, PropsWithChildren} from "react";
import {SectionProps, ColumnSection} from "@common-core/react-content-sections";
import "./TabColumn.scss";

export const TabColumn: FC<PropsWithChildren<SectionProps>> = ({
  name,
  qualifier,
  header,
  description,
  style,
  className,
  children
}) => {
  return (
    <ColumnSection
      type={"tab"}
      name={name}
      qualifier={qualifier}
      header={header}
      description={description}
      style={style}
      className={className}>
      {children}
    </ColumnSection>
  );
};
